import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ad-placeholder-content" }
const _hoisted_2 = { class: "text-center p-4" }
const _hoisted_3 = { class: "text-xs text-gray-500 dark:text-gray-400" }

import { computed } from 'vue';

interface Props {
  adType: 'banner' | 'rectangle' | 'square' | 'infeed';
  show?: boolean;
  className?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AdPlaceholder',
  props: {
    adType: {},
    show: { type: Boolean, default: true },
    className: { default: '' }
  },
  setup(__props: any) {

const props = __props;

const shouldShow = computed(() => props.show);

const containerClasses = computed(() => [
  'ad-placeholder',
  props.className,
  {
    'ad-banner-placeholder': props.adType === 'banner',
    'ad-rectangle-placeholder': props.adType === 'rectangle',
    'ad-square-placeholder': props.adType === 'square',
    'ad-infeed-placeholder': props.adType === 'infeed'
  }
]);

const placeholderText = computed(() => {
  switch (props.adType) {
    case 'banner':
      return 'Banner Advertisement Space';
    case 'rectangle':
      return 'Advertisement';
    case 'square':
      return 'Advertisement';
    case 'infeed':
      return 'Sponsored Content';
    default:
      return 'Advertisement';
  }
});

return (_ctx: any,_cache: any) => {
  return (shouldShow.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(containerClasses.value),
        role: "complementary",
        "aria-label": "Advertisement space"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-gray-400 dark:text-gray-500 mb-2" }, [
              _createElementVNode("svg", {
                class: "w-8 h-8 mx-auto",
                fill: "currentColor",
                viewBox: "0 0 20 20"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z",
                  "clip-rule": "evenodd"
                })
              ])
            ], -1)),
            _createElementVNode("p", _hoisted_3, _toDisplayString(placeholderText.value), 1)
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})